const icons = { 'image': 'file-image',
  'audio': 'file-audio',
  video: 'file-video',
  'application/pdf': 'file-pdf',
  'application/msword': 'file-word',
  'application/vnd.ms-word': 'file-word',
  'application/vnd.oasis.opendocument.text': 'file-word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml': 'file-word',
  'application/vnd.ms-excel': 'file-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml': 'file-excel',
  'application/vnd.oasis.opendocument.spreadsheet': 'file-excel',
  'application/vnd.ms-powerpoint': 'file-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml': 'file-powerpoint',
  'application/vnd.oasis.opendocument.presentation': 'file-powerpoint',
  'application/gzip': 'file-archive',
  'application/zip': 'file-archive',
  'application/x-zip-compressed': 'file-archive',
  'text/plain': 'file-alt',
  'text/html': 'file-code',
  'application/json': 'file-code',
  'message/rfc822': 'envelope'
};

export default {
  getIcon(mimeType) {
    let icon = icons[mimeType];
    if (!icon) {
      const mediaType = mimeType.split('/')[0];
      icon = icons[mediaType];
      if (!icon) {
        icon = 'file';
      }
    }
    return icon;
  }
};
